import Header from "./components/Header";
import Footer from "./components/Footer";
import btn_pink from './assets/images/btn_pink.png';
import {useEffect, useState} from "react";
import FAQ from "./components/FAQ";
import CardsBlock from "./components/CardsBlock";
import CashBlock from "./components/CashBlock";
import Leaderboard from "./components/Leaderboard";

function App() {
    const [staked, setStaked] = useState(false);
    const [leaderboard, setLeaderboard] = useState(false);

    useEffect(() => {
        if (leaderboard) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [leaderboard])

    return (
        <div className="relative">
            <Header staked={staked}/>
            <div className="flex flex-col gap-7 px-5 lg:px-20 w-full lg:w-[75%]">
                <h1 className="font-anton text-[60px] lg:text-[90px] leading-[110%]"><span className="text-[#F373FF]">Staking event:</span> The Arrival of a Driving Legend</h1>
                {
                    !staked &&
                    <>
                        <p className="text-[30px] leading-[120%]">Rolling Bones launches its legendary Staking event to
                            benefit the community with 1000 free mints dedicated to cars of Meta Drive NFT, a collection
                            so magnificent that it sends shockwaves through the NFT universe. </p>
                        <p className="text-[#F373FF] text-[30px] leading-[120%]">Weekly giveaway for stakers of Rolling
                            Bones NFT.</p>
                        <div className="relative w-max cursor-pointer hvr-grow-rotate" onClick={() => setStaked(true)}>
                            <img className="opacity-70 w-[350px] lg:w-[400px]" src={btn_pink} alt="pink_btn"/>
                            <p className="absolute text-[30px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pr-10 pb-3">Stake</p>
                        </div>
                    </>
                }
            </div>
            {
                staked &&
                <>
                    <CashBlock openLeaderboard={setLeaderboard}/>
                    <CardsBlock/>
                </>
            }
            {
                leaderboard
                &&
                <Leaderboard setLeaderboard={setLeaderboard}/>
            }
            <div className="w-full">
                <h1 className="text-[40px] px-5 lg:px-20 mt-20 mb-5">frequently asked questions</h1>
                <div className="bg-[#171717] px-5 lg:px-20 flex flex-col gap-2">
                    <FAQ question={"01. How does it work?"}>
                        01. Stake your Rolling Bones NFTs <br/>
                        02. Earn Speed Cash tokens <br/>
                        03. At the end of "The Arrival of a Driving Legend" event, a snapshot will be taken, and the top
                        1000 wallets with the biggest holdings of Speed Cash will get Meta Drive NFTs
                    </FAQ>
                    <FAQ question={"02. Is there any lock-up period for staked NFTs?"}>
                        No, there is no lock-up period. However, we charge 0.05 SOL for each staking/unstaking
                        transaction to form a liquidity pool aimed at performing buybacks and distributing these NFTs
                        among true supporters.
                    </FAQ>
                    <FAQ question={"03. What is Meta Drive Car NFT?"}>
                        Meta Drive NFT is a non-fungible token represented in the form of cars that can be used for
                        driving and getting rewards inside gaming scenarios of our mobile application. <br/>
                        There are 5 types of Meta Drive NFTs:
                        <ul className="ml-10 list-disc">
                            <li>City Car;</li>
                            <li>Off-Road Car;</li>
                            <li>Travel Car;</li>
                            <li>Sports Car;</li>
                            <li>Electric Car.</li>
                        </ul>
                    </FAQ>
                    <FAQ question={"04. What is a Speed Cash?"}>
                        Speed Cash is a specially designed virtual currency token that is used to reward the user for
                        Staking Event that grants access to free Meta Drive NFTs.
                    </FAQ>
                    <FAQ question={"05. How much Speed Cash do I farm daily?"}>
                        It depends on the number of NFTs you are going to stake - <br/>
                        <ul className="ml-10 list-disc">
                            <li>1 NFT - 100 Speed Cash per day</li>
                            <li>2 NFTs - 250 Speed Cash per day</li>
                            <li>3 NFTs - 500 Speed Cash per day</li>
                            <li>5 NFTs - 900 Speed Cash per day,</li>
                            <li>10 NFTs - 2000 Speed Cash per day</li>
                        </ul>
                    </FAQ>
                    <FAQ question={"06. Do I 100% get free Meta Drive NFT if I stake?"}>
                        Actually, we cannot guarantee free mint to each Staker, because the number of Stakers can exceed
                        the number of allocation of free NFTs worth 1000. Top 1000 Stakers with the biggest earnings of
                        Speed Cash will get free Meta Drive NFT.
                    </FAQ>
                    <FAQ question={"07. Do I get Meta Drive NFT for free? When will I get my Meta Drive Car NFT?"}>
                        Yes, it's absolutely free. You will be able to mint your Meta Drive Car NFT with the launch of
                        the official Meta Drive NFT mint event.
                    </FAQ>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default App;
